import angular from "angular";

angular
    .module('api-sentinel')
    .factory('AnchortagsService', AnchortagsService);

AnchortagsService.$inject = ['$resource', 'SENTINEL_API_HOST_CONSTANTS'];

function AnchortagsService($resource, HOST) {
    var api = $resource(HOST.URL + '/SentinelLogTag', {}, {
        getAnchorTagsBySentinel: {
            method: 'GET',
            url: HOST.URL + '/SentinelAnchorTag/GetSentinelAnchorTagBySentinelID'
        },
        postAnchorTagsBySentinel: {
            method: 'POST',
            url: HOST.URL + '/SentinelAnchorTag/EditSentinelAnchorTagBySentinelID'
        },
        searchBySentinelId: {
            method: 'GET',
            params: { pattern: '@pattern' },
            url: HOST.URL + '/SentinelAnchorTag/GetSentinelAnchorTagListBySentinelID?pattern=:pattern',
            isArray: true
        },
    });

    var service = {
        getAnchorTagsBySentinel: getAnchorTagsBySentinel,
        postAnchorTagsBySentinel: postAnchorTagsBySentinel,
        searchBySentinelId: searchBySentinelId
    };

    return service;

    function getAnchorTagsBySentinel(sentinelId) {
        return api.getAnchorTagsBySentinel({ sentinelId: sentinelId });
    }

    function postAnchorTagsBySentinel(anchortag) {
        return api.postAnchorTagsBySentinel({}, anchortag);
    }

    function searchBySentinelId(account, pattern) {
        return api.searchBySentinelId({ pattern: pattern, accountId: account.id });
    }
}
